export interface FilterFieldDef {
  field: string;
  param: string;
  type: 'string' | 'number' | 'boolean' | 'comma-separated-strings' | 'comma-separated-numbers';
}

export const LEAD_FILTER_FIELDS: FilterFieldDef[] = [
  { field: 'search', param: 'search', type: 'string' },
  { field: 'pipelineStageId', param: 'pipelineStageId', type: 'number' },
  { field: 'closingStatus', param: 'closingStatus', type: 'number' },
  { field: 'assigneeUserId', param: 'assigneeUserId', type: 'string' },
  { field: 'contactIds', param: 'contactIds', type: 'comma-separated-strings' },
  { field: 'contactCategoryId', param: 'contactCategoryId', type: 'number' },
  { field: 'sourceId', param: 'sourceId', type: 'number' },
  { field: 'campaignId', param: 'campaignId', type: 'string' },
  { field: 'referralContactId', param: 'referralContactId', type: 'string' },
  { field: 'salesPersonId', param: 'salesPersonId', type: 'string' },
  { field: 'createdFrom', param: 'createdFrom', type: 'string' },
  { field: 'createdTo', param: 'createdTo', type: 'string' },
  { field: 'segmentIds', param: 'segmentIds', type: 'comma-separated-strings' },
  { field: 'hasReferral', param: 'hasReferral', type: 'boolean' },
];

export const TASK_FILTER_FIELDS: FilterFieldDef[] = [
  { field: 'searchText', param: 'search', type: 'string' },
  { field: 'statusFilter', param: 'status', type: 'number' },
  { field: 'priorityFilter', param: 'priority', type: 'number' },
  { field: 'assigneeFilter', param: 'assigneeId', type: 'string' },
  { field: 'contactFilter', param: 'contactId', type: 'string' },
  { field: 'taskTypeFilter', param: 'taskType', type: 'number' },
  { field: 'isOverdue', param: 'isOverdue', type: 'boolean' },
  { field: 'completedLate', param: 'completedLate', type: 'boolean' },
  { field: 'dueFrom', param: 'dueFrom', type: 'string' },
  { field: 'dueTo', param: 'dueTo', type: 'string' },
  { field: 'createdFrom', param: 'createdFrom', type: 'string' },
  { field: 'createdTo', param: 'createdTo', type: 'string' },
  { field: 'segmentIds', param: 'segmentIds', type: 'comma-separated-strings' },
  { field: 'contactCategoryIds', param: 'contactCategoryIds', type: 'comma-separated-numbers' },
  { field: 'batchNameFilter', param: 'batchName', type: 'string' },
];

export const CONTACT_FILTER_FIELDS: FilterFieldDef[] = [
  { field: 'search', param: 'search', type: 'string' },
  { field: 'phone', param: 'phone', type: 'string' },
  { field: 'categoryId', param: 'categoryId', type: 'number' },
  { field: 'contactType', param: 'contactType', type: 'number' },
  { field: 'role', param: 'role', type: 'number' },
  { field: 'ownerUserId', param: 'ownerUserId', type: 'string' },
  { field: 'createdFrom', param: 'createdFrom', type: 'string' },
  { field: 'createdTo', param: 'createdTo', type: 'string' },
  { field: 'segmentIds', param: 'segmentIds', type: 'comma-separated-strings' },
  { field: 'contactCategoryIds', param: 'contactCategoryIds', type: 'comma-separated-numbers' },
  { field: 'lastActivity', param: 'lastActivity', type: 'string' },
];

export const DOCUMENT_FILTER_FIELDS: FilterFieldDef[] = [
  { field: 'search', param: 'search', type: 'string' },
  { field: 'status', param: 'status', type: 'number' },
];

export const CAMPAIGN_FILTER_FIELDS: FilterFieldDef[] = [
  { field: 'status', param: 'status', type: 'number' },
  { field: 'channelId', param: 'channelId', type: 'number' },
];

export const OFFERING_FILTER_FIELDS: FilterFieldDef[] = [
  { field: 'search', param: 'search', type: 'string' },
  { field: 'status', param: 'status', type: 'number' },
  { field: 'offeringCategoryId', param: 'offeringCategoryId', type: 'number' },
  { field: 'hasActiveDiscount', param: 'hasActiveDiscount', type: 'boolean' },
  { field: 'minBasePrice', param: 'minBasePrice', type: 'number' },
  { field: 'maxBasePrice', param: 'maxBasePrice', type: 'number' },
];

export const DASHBOARD_FILTER_FIELDS: FilterFieldDef[] = [
  { field: 'segmentIds', param: 'segmentIds', type: 'comma-separated-strings' },
  { field: 'contactCategoryIds', param: 'contactCategoryIds', type: 'comma-separated-numbers' },
  { field: 'assigneeIds', param: 'assigneeIds', type: 'comma-separated-strings' },
];

export const KANBAN_FILTER_FIELDS: FilterFieldDef[] = [
  { field: 'sourceFilter', param: 'sourceId', type: 'number' },
  { field: 'campaignFilter', param: 'campaignId', type: 'string' },
  { field: 'contactCategoryFilter', param: 'contactCategoryId', type: 'number' },
  { field: 'contactFilters', param: 'contactIds', type: 'comma-separated-strings' },
  { field: 'segmentFilter', param: 'segmentIds', type: 'comma-separated-strings' },
];

export const PAGE_FILTER_MAP: Record<string, FilterFieldDef[]> = {
  '/leads': LEAD_FILTER_FIELDS,
  '/leads/pipeline': KANBAN_FILTER_FIELDS,
  '/tasks': TASK_FILTER_FIELDS,
  '/contacts': CONTACT_FILTER_FIELDS,
  '/documents': DOCUMENT_FILTER_FIELDS,
  '/campaigns': CAMPAIGN_FILTER_FIELDS,
  '/offerings': OFFERING_FILTER_FIELDS,
};
